import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { ApiResponse } from '@/types';

interface OAuthStatus {
  github: boolean;
  google: boolean;
}

export function useOAuthStatus() {
  return useQuery({
    queryKey: ['oauthStatus'],
    queryFn: async (): Promise<OAuthStatus> => {
      const response = await api.get<ApiResponse<OAuthStatus>>('/oauth/status');
      if (!response.data.success || !response.data.data) {
        return { github: false, google: false };
      }
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
